import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4835 2.17026C11.7727 1.89562 12.2263 1.89536 12.5158 2.16967C14.5319 4.07976 17.2532 5.24911 20.25 5.24911H20.402C20.726 5.24911 21.0133 5.4571 21.1145 5.76484C21.527 7.01948 21.75 8.35952 21.75 9.75011C21.75 15.6926 17.6863 20.6832 12.1869 22.0984C12.0643 22.13 11.9356 22.13 11.813 22.0984C6.31373 20.6822 2.25 15.6916 2.25 9.74911H3L2.25 9.74972C2.25 9.74952 2.25 9.74931 2.25 9.74911C2.24898 8.39616 2.46346 7.05168 2.88541 5.76621C2.98769 5.45462 3.28055 5.24561 3.60847 5.25018C6.53492 5.29103 9.36128 4.18565 11.4835 2.17026ZM12.0005 3.72184C9.80566 5.58939 7.03907 6.65657 4.15614 6.74526C3.88602 7.72263 3.74918 8.73286 3.75 9.74851L3.75 9.74911C3.75 14.9231 7.24249 19.2824 12.0001 20.5959C16.7575 19.2833 20.25 14.9241 20.25 9.75011C20.25 8.70762 20.1083 7.69925 19.8437 6.74276C16.8565 6.64927 14.1274 5.52866 12.0005 3.72184ZM9.21967 9.79534C9.51256 9.50245 9.98744 9.50245 10.2803 9.79534L12 11.515L13.7197 9.79534C14.0126 9.50245 14.4874 9.50245 14.7803 9.79534C15.0732 10.0882 15.0732 10.5631 14.7803 10.856L13.0607 12.5757L14.7803 14.2953C15.0732 14.5882 15.0732 15.0631 14.7803 15.356C14.4874 15.6489 14.0126 15.6489 13.7197 15.356L12 13.6363L10.2803 15.356C9.98744 15.6489 9.51256 15.6489 9.21967 15.356C8.92678 15.0631 8.92678 14.5882 9.21967 14.2953L10.9393 12.5757L9.21967 10.856C8.92678 10.5631 8.92678 10.0882 9.21967 9.79534Z"
        fill={colorValue}
      />
    </svg>
  );
};
